import { useMemo, useState } from 'react';

import { Button, Dialog } from '../../../components/ui';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { loiTheoTruong } from '../../../lib/errors';
import { useToast } from '../../../lib/toast';
import { useLuaChonModelAi } from '../../ai-model/hooks/useAiModels';
import { useGhiKhoOcr } from '../hooks/useKhoOcr';
import { modelDocChu, modelDocChuMacDinh } from '../nghiep-vu/kho-ocr';
import type { OcrFile } from '../types';
import { ChonModelDocChu } from './ChonModelDocChu';

/**
 * Đọc lại một tài liệu thành bản OCR mới (`POST /ocr-files/{id}/versions`). Mặc định chọn sẵn model
 * của bản đang dùng nếu còn bật, không thì model đọc chữ mặc định. Lỗi (kể cả `409` đang đọc) hiện
 * trong hộp, hộp không đóng. Phía gọi gắn `key` theo tài liệu để hộp bắt đầu đúng model.
 */
export function HopDocLai({ tep, onClose }: { tep: OcrFile | null; onClose: () => void }) {
  const { t } = useT();
  const dichLoi = useLoi();
  const toast = useToast();
  const luaChon = useLuaChonModelAi();
  const { docLai } = useGhiKhoOcr();
  const [model, setModel] = useState<string | undefined>();

  const docChu = useMemo(() => modelDocChu(luaChon.data ?? []), [luaChon.data]);
  const banDung = tep?.effective?.reader_key;
  const modelChon =
    model ?? (banDung && docChu.some((m) => m.key === banDung) ? banDung : modelDocChuMacDinh(luaChon.data ?? []));
  const loiServer = loiTheoTruong(docLai.error);
  const ten = tep?.file_name ?? '';

  const gui = () => {
    if (!tep || !modelChon) return;
    docLai.mutate(
      { id: tep.id, reader_key: modelChon },
      {
        onSuccess: () => {
          toast.success(t('khoOcr.daDocLai', { ten }));
          onClose();
        },
      },
    );
  };

  return (
    <Dialog
      open={tep !== null}
      onClose={onClose}
      title={t('khoOcr.hopDocLaiTieuDe', { ten })}
      width={520}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button variant="primary" size="md" loading={docLai.isPending} disabled={!modelChon} onClick={gui}>
            {t('khoOcr.docLaiNut')}
          </Button>
        </div>
      }
    >
      <div className="space-y-4 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">{t('khoOcr.hopDocLaiMo')}</p>
        <ChonModelDocChu
          ds={docChu}
          dangTai={luaChon.isLoading}
          value={modelChon}
          onChange={setModel}
          error={loiServer['/reader_key']}
        />
        {docLai.error && !loiServer['/reader_key'] && <LoiTrongHop>{dichLoi(docLai.error)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
